import { getAccessToken } from "@/utils/tokenStore";
import axios from "axios";

const getAuthHeader = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getAccessToken()}`,
});

export async function getAuthToken(companyId) {
  const response = await axios.post(
    `${process.env.VUE_APP_SERVERURL}/voicebot-sso/auth`,
    { companyId },
    { headers: getAuthHeader() }
  );
  return response.data;
}

export async function checkVoicebotAccess(companyId) {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_SERVERURL}/voicebot-sso/access/${companyId}`,
      { headers: getAuthHeader() }
    );
    return response.data.hasAccess;
  } catch (error) {
    console.error("[VoicebotSSO] 접근 권한 확인 실패:", error);
    return false;
  }
}

export async function openVoicebotAdmin(companyId) {
  const { result, token, loginUrl } = await getAuthToken(companyId);

  if (result === "success" && token && loginUrl) {
    window.open(`${loginUrl}?token=${token}`, "_blank");
    return true;
  }

  console.error("[VoicebotSSO] 응답 데이터 오류:", { result, token, loginUrl });
  return false;
}

export default {
  getAuthToken,
  checkVoicebotAccess,
  openVoicebotAdmin,
};
